import React, { useEffect } from "react";
import { useGetAllCategoriesQuery } from "../redux/feature/slice/service-api";
import { Link } from "react-router-dom";
import CategorySkeletonLoader from "../components/loading/categorySkeletonLoader";
import Title from "../components/helmet/title";

const CategoryPage = () => {
  const { isLoading, data: Categories } = useGetAllCategoriesQuery();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // only for small device categories page
  return (
    <section className="container mx-auto px-2 lg:px-20 my-8 block md:hidden mt-14 md:mt-0">
      <Title title={"Category"} content={"This is categories page"} />
      <h2 className="text-xl md:text-3xl font-bold mb-2 uppercase">
        Categories
      </h2>

      <div className="bg-white grid grid-cols-3 md:grid-cols-5 mx-auto justify-center lg:grid-cols-5 xl:grid-cols-8">
        {isLoading && <CategorySkeletonLoader />}
        {Categories?.data?.map((category) => (
          <div key={category?.id} className="w-34 p-4 border hover:shadow-lg">
            <Link to={`/all-products/${category?.name}/${category?.id}`}>
              <div className="mx-auto flex justify-center">
                <img
                  src={category?.imageUrl}
                  alt={category?.name}
                  className="w-32 h-28 my-2"
                />
              </div>
              <p className="text-center">{category?.name}</p>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CategoryPage;
